import { render } from "./wMenuLabel.vue?vue&type=template&id=2bd25a20&ts=true"
import script from "./wMenuLabel.vue?vue&type=script&lang=ts"
export * from "./wMenuLabel.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__